export default __webpack_public_path__ + "static/media/wa-3634.6053a428.jpg";